import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
// Usar jQuery global desde CDN
// import $ from 'jquery';
// import 'select2/dist/css/select2.min.css';
// import 'select2';

import TituloAdmin from '@components/TituloAdmin';
import Boton from '@components/Boton';
import {
  createOficinaEspecialidadSedeApi,
  getAllOficinasEspecialidadesSedesApi,
  deleteOficinaEspecialidadSedeApi,
  bulkCreateOficinaEspecialidadSedeApi,
  getByEspecialidadApi
} from "@api/wp/especialidadesSedes/especialidadesSedesApi";
import { getAllEspecialidadesApi } from "@api/wp/especialidades/especialidadesApi";
import { getSedesByEmpresaApi } from "@api/wp/sedes/sedesApi";

import { cajaPrincipalStyle } from '@styles/cajaPrincipal';
import { cajaContenedorAdminStyle } from '@styles/cajaContenedorAdmin';

import { cajaContenedorPrimeroStyle } from '@styles/cajaContenedorPrimero';
import { tablaEstylos, tablaTheadEstylos } from '@styles/tablaEstylos';
import { colors } from '@styles/colors';
import { selectStyle } from '@styles/selecsEstylos';
import Label from '@components/Label';

function SedesEspecialidades() {
  const navigate = useNavigate();
  // Estados para los datos
  const [especialidades, setEspecialidades] = useState([]);
  const [sedes, setSedes] = useState([]);
  const [sedesEspecialidades, setSedesEspecialidades] = useState([]);

  // Estados para el control de la UI
  const [cargando, setCargando] = useState(false);
  const [procesando, setProcesando] = useState(false);
  const [error, setError] = useState('');
  const [mensaje, setMensaje] = useState('');

  // Estados para el formulario
  const [especialidadSeleccionada, setEspecialidadSeleccionada] = useState('');
  const [sedesSeleccionadas, setSedesSeleccionadas] = useState([]);

  // Ref para el select de sedes
  const sedesSelectRef = useRef(null);
  // Ref para el select de especialidades
  const especialidadSelectRef = useRef(null);
  // Ref para la tabla de relaciones y contenedor de botones DataTables
  const tablaRelacionesRef = useRef(null);
  const dtButtonsContainerRef = useRef(null);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      navigate('/login');
    }
  }, [navigate]);

  useEffect(() => {
    cargarDatos();
  }, []);

  // Inicializar Select2 cuando las sedes se cargan
  useEffect(() => {
    if (sedes.length > 0 && sedesSelectRef.current && window.$ && especialidadSeleccionada) {
      initializeSelect2();
    }
    
    // Cleanup function
    return () => {
      if (sedesSelectRef.current && window.$ && window.$(sedesSelectRef.current).hasClass('select2-hidden-accessible')) {
        window.$(sedesSelectRef.current).select2('destroy');
      }
    };
  }, [sedes]);

  // Inicializar Select2 en el select de especialidades cuando cambian las opciones
  useEffect(() => {
    if (especialidadSelectRef.current && window.$) {
      const $ = window.$;
      // Destruir si ya está inicializado
      if ($(especialidadSelectRef.current).hasClass('select2-hidden-accessible')) {
        $(especialidadSelectRef.current).select2('destroy');
      }

      // Inicializar con buscador
      $(especialidadSelectRef.current).select2({
        placeholder: '-- Seleccione una especialidad --',
        allowClear: true,
        width: '100%',
        theme: 'default',
        minimumResultsForSearch: 0,
        language: {
          noResults: function() {
            return "No se encontraron resultados";
          },
          searching: function() {
            return "Buscando...";
          }
        }
      });

      // Manejar cambios
      $(especialidadSelectRef.current).on('change', function() {
        const value = $(this).val() || '';
        setEspecialidadSeleccionada(value);
      });
    }

    // Cleanup
    return () => {
      if (especialidadSelectRef.current && window.$) {
        const $ = window.$;
        if ($(especialidadSelectRef.current).hasClass('select2-hidden-accessible')) {
          $(especialidadSelectRef.current).select2('destroy');
        }
      }
    };
  }, [especialidades]);

  // Inicializar/Destruir Select2 cuando cambia la especialidad seleccionada
  useEffect(() => {
    if (sedesSelectRef.current && window.$) {
      const $ = window.$;
      // Si hay especialidad seleccionada y sedes cargadas, inicializar
      if (especialidadSeleccionada && sedes.length > 0) {
        if ($(sedesSelectRef.current).hasClass('select2-hidden-accessible')) {
          $(sedesSelectRef.current).select2('destroy');
        }
        initializeSelect2();
      } else {
        // Si no hay especialidad seleccionada, limpiar y destruir
        $(sedesSelectRef.current).val(null).trigger('change');
        if ($(sedesSelectRef.current).hasClass('select2-hidden-accessible')) {
          $(sedesSelectRef.current).select2('destroy');
        }
        setSedesSeleccionadas([]);
      }
    }
  }, [especialidadSeleccionada]);

  // Función para inicializar Select2
  const initializeSelect2 = () => {
    if (sedesSelectRef.current && window.$) {
      const $ = window.$;
      
      // Destruir Select2 existente si existe
      if ($(sedesSelectRef.current).hasClass('select2-hidden-accessible')) {
        $(sedesSelectRef.current).select2('destroy');
      }

      // Inicializar Select2 con configuración personalizada
      $(sedesSelectRef.current).select2({
        placeholder: '-- Seleccione una o más sedes --',
        allowClear: true,
        width: '100%',
        theme: 'default',
        minimumResultsForSearch: 0,
        language: {
          noResults: function() {
            return "No se encontraron resultados";
          },
          searching: function() {
            return "Buscando...";
          }
        }
      });

      // Manejar cambios en la selección
      $(sedesSelectRef.current).on('change', function() {
        const selectedValues = $(this).val() || [];
        setSedesSeleccionadas(selectedValues.map(val => parseInt(val)));
      });

      // Aplicar selección inicial si existe
      if (sedesSeleccionadas && sedesSeleccionadas.length > 0) {
        $(sedesSelectRef.current).val(sedesSeleccionadas.map(String)).trigger('change');
      }
    }
  };

  // Función para cargar especialidades y relaciones (sin sedes inicialmente)
  const cargarDatos = async () => {
    try {
      setCargando(true);
      setError('');
      setMensaje('');

      // Cargar especialidades y relaciones existentes en paralelo
      const [especialidadesResponse, relacionesResponse] = await Promise.all([
        getAllEspecialidadesApi(),
        getAllOficinasEspecialidadesSedesApi()
      ]);

      setEspecialidades(especialidadesResponse.result || []);
      // No cargar sedes inicialmente
      setSedes([]);
      setSedesEspecialidades(relacionesResponse.result || []);

      if (relacionesResponse.result && relacionesResponse.result.length > 0) {
        setMensaje(`Se cargaron ${relacionesResponse.result.length} relaciones especialidad-sede`);
      }

    } catch (err) {
      setError('Error al cargar los datos: ' + err.message);
      console.error('Error:', err);
    } finally {
      setCargando(false);
    }
  };

  // Cargar sedes por empresa cuando se selecciona una especialidad
  useEffect(() => {
    const cargarSedesPorEmpresa = async () => {
      if (!especialidadSeleccionada) {
        setSedes([]);
        setSedesSeleccionadas([]);
        if (sedesSelectRef.current && window.$) {
          window.$(sedesSelectRef.current).val(null).trigger('change');
        }
        return;
      }

      try {
        // Encontrar la especialidad seleccionada por su oid_especialidad
        const espSel = especialidades.find(
          (e) => String(e.oid_especialidad) === String(especialidadSeleccionada)
        );
        const idEmp = espSel?.idEmp;
        const idEsp = espSel?.id;

        if (!idEmp) {
//          setSedes([]);
  //        setSedesSeleccionadas([]);
          return;
        }
        const resp = await getSedesByEmpresaApi(idEmp);
        setSedes(resp.result || []);

        // Preseleccionar sedes ya relacionadas a la especialidad
        if (idEsp) {
          const relacionesResp = await getByEspecialidadApi(idEsp);
          const seleccionadas = (relacionesResp.result || []).map(r => parseInt(r.idSed));
          setSedesSeleccionadas(seleccionadas);
          if (sedesSelectRef.current && window.$) {
            window.$(sedesSelectRef.current).val(seleccionadas.map(String)).trigger('change');
          }
        }
      } catch (err) {
        console.error('Error al cargar sedes por empresa:', err);
        setError('Error al cargar sedes por empresa: ' + (err?.message || 'Error desconocido'));
        setSedes([]);
        setSedesSeleccionadas([]);
      }
    };

    cargarSedesPorEmpresa();
  }, [especialidadSeleccionada, especialidades]);

  // Función para crear relaciones especialidad-sede en bloque (bulk)
  const crearRelaciones = async () => {
    if (!especialidadSeleccionada || sedesSeleccionadas.length === 0) {
      setError('Por favor seleccione una especialidad y al menos una sede');
      return;
    }

    try {
      setProcesando(true);
      setError('');
      setMensaje('');

      // Encontrar la especialidad seleccionada por su OID para obtener su ID interno
      const espSel = especialidades.find(
        (e) => String(e.oid_especialidad) === String(especialidadSeleccionada)
      );
      const idEsp = espSel?.id;

      if (!idEsp) {
        setError('No se pudo determinar el ID interno de la especialidad seleccionada');
        return;
      }

      const data = {
        idEsp: parseInt(idEsp),
        idSeds: sedesSeleccionadas.map((id) => parseInt(id))
      };

      console.log('Enviando bulkCreate relaciones especialidad-sede:', data);
      const response = await bulkCreateOficinaEspecialidadSedeApi(data);

      // Limpiar el formulario
      setEspecialidadSeleccionada('');
      setSedesSeleccionadas([]);

      // Limpiar Select2
      if (sedesSelectRef.current && window.$) {
        window.$(sedesSelectRef.current).val(null).trigger('change');
      }

      // Recargar los datos
      await cargarDatos();

      // Mostrar resumen si el backend lo provee
      if (response?.statusCode === 201 && response?.result?.summary) {
        const { inserted = 0, skipped = 0, errors = 0 } = response.result.summary;
        setMensaje(`Insertadas: ${inserted} | Omitidas: ${skipped} | Errores: ${errors}`);
      } else {
        setMensaje('Relaciones procesadas correctamente');
      }

      alert('Operación completada exitosamente');

    } catch (err) {
      console.error('Error al crear relaciones:', err);
      setError('Error al crear relaciones: ' + (err?.message || 'Error desconocido'));
    } finally {
      setProcesando(false);
    }
  };

  // Función para eliminar una relación
  const eliminarRelacion = async (id) => {
    if (!window.confirm('¿Está seguro de que desea eliminar esta relación?')) {
      return;
    }

    try {
      setProcesando(true);
      setError('');
      setMensaje('');

      await deleteOficinaEspecialidadSedeApi(id);
      
      // Recargar los datos
      await cargarDatos();
      
      setMensaje('Relación eliminada exitosamente');

    } catch (err) {
      setError('Error al eliminar la relación: ' + err.message);
      console.error('Error:', err);
    } finally {
      setProcesando(false);
    }
  };

  
  const thStyle = {
    padding: '2vh 1.5vh',
    textAlign: 'left',
    fontWeight: '600',
    fontSize: '1.6vh',
    textTransform: 'uppercase',
    letterSpacing: '0.05vh',
    fontFamily: 'Inter'
  };

  const tdStyle = {
    border: `1px solid ${colors.gray200}`,
    padding: '1.5vh',
    fontSize: '1.6vh',
    color: colors.gray600,
    fontFamily: 'Inter'
  };

  const deleteButtonStyle = {
    backgroundColor: colors.error,
    color: colors.white,
    border: 'none',
    padding: '0.8vh 1.6vh',
    borderRadius: '0.6vh',
    cursor: 'pointer',
    fontSize: '1.2vh',
    fontWeight: '500',
    transition: 'all 0.3s ease',
    textTransform: 'uppercase',
    letterSpacing: '0.05vh',
    fontFamily: 'Inter'
  };

  const alertStyle = (type) => ({
    padding: '1.5vh 2vh',
    marginBottom: '2vh',
    borderRadius: '0.8vh',
    fontSize: '1.4vh',
    fontWeight: '500',
    fontFamily: 'Inter',
    border: `1px solid ${type === 'error' ? colors.errorText : colors.primary}`,
    backgroundColor: type === 'error' ? colors.errorShadow : colors.resumenBg,
    color: type === 'error' ? colors.errorText : colors.primaryText
  });

  // Inicializar DataTables con exportación a Excel (Buttons)
  useEffect(() => {
    try {
      if (!tablaRelacionesRef.current || cargando || sedesEspecialidades.length === 0) {
        return;
      }
      const $ = window.$;
      if (!$ || !$.fn || !$.fn.dataTable) {
        return;
      }

      const $table = $(tablaRelacionesRef.current);

      // Destruir instancia previa si existe
      if ($.fn.dataTable.isDataTable($table)) {
        $table.DataTable().destroy();
      }

      const dt = $table.DataTable({
        dom: 'Bfrtip',
        buttons: [
          {
            extend: 'excelHtml5',
            title: 'Relaciones especialidad-sede',
            exportOptions: { columns: [0, 1, 2] }
          }
        ],
        language: {
          url: 'https://cdn.datatables.net/plug-ins/1.13.6/i18n/es-ES.json'
        },
        paging: true,
        searching: true,
        ordering: true
      });

      // Mover los botones debajo de la tabla
      if (dtButtonsContainerRef.current) {
        dt.buttons().container().appendTo(dtButtonsContainerRef.current);
      }

      // Cleanup al desmontar o cambiar datos
      return () => {
        if ($.fn.dataTable.isDataTable($table)) {
          $table.DataTable().destroy();
        }
      };
    } catch (e) {
      console.error('Error inicializando DataTables:', e);
    }
  }, [sedesEspecialidades, cargando]);

  return (
    <div style={cajaPrincipalStyle}>
      <TituloAdmin
        titulo="Administración de especialidades"
        imagen_titulo='especial'
        subtitulo="Gestión y visualización de la asignación de especialidades a sedes"
      />

      {/* Div central */}
      <div style={cajaContenedorAdminStyle}>

          {/* Mensajes de estado */}
          {error && (
            <div style={alertStyle('error')}>
              <strong>Error:</strong> {error}
            </div>
          )}

          {/* Formulario para crear nueva relación - SIN recuadro grisáceo */}
          <div style={{ marginTop: '0vh', width: '100vh' }}>
            <div style={{ 
              display: 'grid', 
              gridTemplateColumns: '1fr 1fr', 
              gap: '2vh',
              marginBottom: '2.5vh'
            }}>
              <div>
                <Label>Seleccionar Especialidad:</Label>
                <select
                  ref={especialidadSelectRef}
                  value={especialidadSeleccionada}
                  onChange={(e) => setEspecialidadSeleccionada(e.target.value)}
                  style={selectStyle}
                  disabled={cargando || procesando}
                  onFocus={(e) => e.target.style.borderColor = colors.primary}
                  onBlur={(e) => e.target.style.borderColor = colors.gray200}
                >
                  <option value="">-- Seleccione una especialidad --</option>
                  {especialidades.map((especialidad) => (
                    <option 
                      key={especialidad.oid_especialidad} 
                      value={especialidad.oid_especialidad}
                      style={{ fontFamily: 'Inter' }}
                    >
                      {especialidad.nombre_especialidad} - {especialidad.nombre_empresa} {especialidad?.num > 0 ? `(${especialidad.num})` : ''}
                    </option>
                  ))}
                </select>
              </div>

              <div>
                <Label>Seleccionar Sedes (Múltiple):</Label>
                <select
                  ref={sedesSelectRef}
                  multiple="multiple"
                  style={{...selectStyle, height: '12vh'}}
                  disabled={cargando || procesando || !especialidadSeleccionada}
                >
                  {sedes.map((sede) => (
                    <option key={sede.id} value={sede.id}>
                      {sede.nombre_sede}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div style={{ textAlign: 'center' }}>
              <Boton
                label={procesando ? "Creando..." : "Guardar"}
                onClick={crearRelaciones}
                disabled={cargando || procesando || !especialidadSeleccionada || sedesSeleccionadas.length === 0}
                ancho="25vh"
                alto="5vh"
              />
            </div>
          </div>

          {/* Lista de relaciones existentes (debajo del formulario) */}
          <div style={{ marginTop: '3vh' }}>
            {cargando ? (
              <div style={{ 
                textAlign: 'center', 
                padding: '4vh',
                color: colors.secondaryButton,
                fontSize: '1.6vh',
                fontFamily: 'Inter'
              }}>
                <div style={{ marginBottom: '1vh' }}>🔄</div>
                Cargando relaciones...
              </div>
            ) : sedesEspecialidades.length === 0 ? (
              <div style={{ 
                textAlign: 'center', 
                padding: '4vh',
                color: colors.secondaryButton,
                fontSize: '1.6vh',
                fontFamily: 'Inter'
              }}>
                <div style={{ marginBottom: '1vh' }}>📋</div>
                No hay relaciones especialidad-sede registradas.
              </div>
            ) : (
              <div style={{ overflowX: 'auto' }}>
                <table ref={tablaRelacionesRef} className="display" style={tablaEstylos}>
                  <thead style={tablaTheadEstylos}>
                    <tr>
                      <th style={thStyle}>ID</th>
                      <th style={thStyle}>Especialidad</th>
                      <th style={thStyle}>Empresa</th>  
                      <th style={thStyle}>Sede</th>
                      <th style={{ ...thStyle, textAlign: 'center' }}>Acciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    {sedesEspecialidades.map((relacion, index) => (
                      <tr key={relacion.id} style={{
                        backgroundColor: index % 2 === 0 ? colors.gray100 : colors.white
                      }}>
                        <td style={tdStyle}>
                          <div style={{ fontWeight: '500' }}>
                            {relacion.oid_especialidad}
                          </div>
                        </td>                        
                        <td style={tdStyle}>
                          <div style={{ fontWeight: '500' }}>
                            {relacion.nombreEspecialidad}
                          </div>
                        </td>
                        <td style={tdStyle}>
                          <div style={{ fontWeight: '500' }}>
                            {relacion.nombre_empresa}
                          </div>
                        </td>
                        <td style={tdStyle}>
                          <div style={{ fontWeight: '500' }}>
                            {relacion.nombreSede || `ID: ${relacion.idSed}`}
                          </div>
                        </td>
                        <td style={{ ...tdStyle, textAlign: 'center' }}>
                          <button
                            onClick={() => eliminarRelacion(relacion.id)}
                            disabled={procesando}
                          style={deleteButtonStyle}
                          onMouseOver={(e) => e.target.style.backgroundColor = colors.errorText}
                          onMouseOut={(e) => e.target.style.backgroundColor = colors.error}
                          >
                            Eliminar
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <div ref={dtButtonsContainerRef} style={{ marginTop: '1.5vh', textAlign: 'center' }}></div>
              <br />
              <br />                
              <br />
              </div>
            )}
          </div>
          
        </div>
    </div>
  );
}

export default SedesEspecialidades;